/* eslint-disable max-lines */
import { Controller } from "stimulus";
import { M } from "@materializecss/materialize/dist/js/materialize";
import dispatchCustomEvent from "../../functions/dispatchCustomEvent.js";
import SelectAllOption from "../../classes/selectAllOption";

export default class extends Controller {
  static get targets() {
    return ["select", "dropdown", "selectAllCheckbox"];
  }

  connect() {
    M.FormSelect.init(this.selectTarget, this.options);
    this.updatePreview();
    this.previewField.addEventListener("focus", this.updatePreview.bind(this));
    this.previewField.placeholder = this.placeholder;
    SelectAllOption.addTo(this.multiSelectDropdown);
    this.addCheckboxListeners();
    dispatchCustomEvent(this.element, "multi-select:loaded");
  }

  disconnect() {
    this.previewField.placeholder = "";
  }

  updatePreview() {
    this.previewField.value = this.truncatedPreviewText;
  }

  get selectedValues() {
    return this.materializeSelect.getSelectedValues();
  }

  get materializeSelect() {
    return M.FormSelect.getInstance(this.selectTarget);
  }

  get truncatedPreviewText() {
    if (!this.firstValue) {
      return "";
    }

    return `${this.firstValue.slice(0, this.availableCharWidth)}... ${this.abbreviation}`;
  }

  get availableCharWidth() {
    return this.visiblePreviewFieldCharWidth - this.abbreviation.length;
  }

  get abbreviation() {
    return `(1 of ${this.selectedValues.length})`;
  }

  get firstValue() {
    return this.previewField.value.split(",")[0];
  }

  get visiblePreviewFieldCharWidth() {
    return this.visiblePreviewFieldPixelWidth / this.charPixelWidth;
  }

  get visiblePreviewFieldPixelWidth() {
    return this.previewFieldPixelWidth - this.caretPixelWidth;
  }

  get charPixelWidth() {
    return 10;
  }

  get caretPixelWidth() {
    return 24;
  }

  get previewFieldPixelWidth() {
    return this.previewField.clientWidth;
  }

  get previewField() {
    return this.element.getElementsByClassName("dropdown-trigger")[0];
  }

  get placeholder() {
    return this.element.dataset.placeholder;
  }

  get options() {
    return {
      dropdownOptions: {
        inDuration: 0,
        outDuration: 0
      }
    };
  }

  addCheckboxListeners() {
    const checkboxes =
    this.element.querySelectorAll(".multiple-select-dropdown li[role='option']");

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener("click", this.updateSelectAllCheckbox.bind(this));
      checkbox.addEventListener("keydown", this.updateSelectAllCheckbox.bind(this));
    });
  }

  updateSelectAllCheckbox() {
    const allOptionsSelected = Array.from(this.checkboxes).every(checkbox => checkbox.checked);
    this.selectAllCheckbox.checked = allOptionsSelected;
  }

  toggleAllCheckboxes() {
    const selectAllCheckboxChecked = this.selectAllCheckbox.checked;

    this.checkboxes.forEach((checkbox) => {
      if (checkbox.checked !== selectAllCheckboxChecked) {
        checkbox.checked = selectAllCheckboxChecked;
        checkbox.click();
      }
    });
  }

  handleKeydown(event) {
    if (event.key === "Enter") this.toggleAllCheckboxes();
  }

  get multiSelectDropdown() {
    return this.element.querySelector(".multiple-select-dropdown");
  }

  get checkboxes() {
    return this.multiSelectDropdown.querySelectorAll("input[type='checkbox']:not(.select-all-checkbox)");
  }

  get selectAllCheckbox() {
    return this.selectAllCheckboxTarget.querySelector("input");
  }

  handleClickOnListItem(event) {
    if (event.target.closest("input[type='checkbox'], label")) {
      return;
    }

    const input = event.target.closest("li").querySelector("input");
    if (input) {
      input.click();
    } else {
      console.error("Input element not found.");
    }
  }
}
